module.exports = __webpack_public_path__ + "img/22_45.b29a19a2.png";